import { Component, Input } from '@angular/core';
import { iconEnum } from '@app/configs/model/IconEnum';

import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'au-logo-placeholder',
	templateUrl: './au-logo-placeholder.component.html',
	styleUrls: ['./au-logo-placeholder.component.scss'],
	imports: [MatIcon],
})
export class AuLogoPlaceholderComponent {
	@Input() logoSrc: string;
	// TODO Refactor it to single icon
	@Input() fallbackSrc = './assets/icons/users.svg';
	@Input() size = 32;
	@Input() noLogoSvgIcon = iconEnum.user;

	constructor() {}
}
